import React from 'react';
import { Navigate } from 'react-router-dom';
import webCore from '@happylife-a/web-core';
import { useAppLocale } from '../contexts';
import * as helpers from '../helpers';

function SimpleRoute({ screen: ScreenComponent }) {
  return <ScreenComponent />;
}

function LayoutRoute({ screen, layout, layoutParams }) {
  const ScreenComponent = screen;
  const LayoutComponent = layout;

  return (
    <LayoutComponent {...(layoutParams || {})}>
      <ScreenComponent />
    </LayoutComponent>
  );
}

function AppRouteItem({ accessLevel, screen, layout, layoutParams, loginUrl }) {
  const { initialPrefix } = useAppLocale();
  const { user, isLoggedIn } = webCore.contexts.useUser();
  if (user === undefined) {
    return null;
  }

  if (accessLevel === 'private' && !isLoggedIn) {
    const normalizedLoginUrl = helpers.url.buildUrlFromParts([initialPrefix, loginUrl]);
    return <Navigate to={normalizedLoginUrl} replace={true} />;
  }
  if (accessLevel === 'guest' && isLoggedIn) {
    const normalizedRedirect = helpers.url.buildUrlFromParts([initialPrefix, '']);
    return <Navigate to={normalizedRedirect} replace={true} />;
  }
  if (!layout) {
    return <SimpleRoute screen={screen} />;
  }

  return <LayoutRoute screen={screen} layout={layout} layoutParams={layoutParams} />;
}

export default AppRouteItem;
